import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../../config/config';
import {
  DateRequest,
  IAnalyticCountResponse,
  IAthleteEducationLevelsResponse,
  IAthletesDistributionAnalyticResponse,
  INumberOfApprovedCandidatesAnalyticResponse,
  INumberOfCandidatesAnalyticResponse,
  ITimeToFillAnalyticResponse,
} from '../../../interfaces/analytic.interface';
import { baseQueryWithInterceptor } from '../../utils/baseQueryWithInterceptor';

const analyticsApi = createApi({
  reducerPath: 'analyticsApi',
  baseQuery: baseQueryWithInterceptor(`${config.API_BASE_URL}/analytic`),
  tagTypes: ['analytic'],

  endpoints: (builder) => ({
    getNumberOfCandidates: builder.query<
      INumberOfCandidatesAnalyticResponse,
      void
    >({
      query: () => '/number-of-categories',
      providesTags: ['analytic'],
    }),
    getNumberOfApprovedCandidates: builder.query<
      INumberOfApprovedCandidatesAnalyticResponse,
      void
    >({
      query: () => '/number-of-approved-candidates',
      providesTags: ['analytic'],
    }),
    getTimeToFill: builder.query<ITimeToFillAnalyticResponse, void>({
      query: () => '/time-to-fill',
      providesTags: ['analytic'],
    }),
    countOfCandidatesByDate: builder.query<IAnalyticCountResponse, DateRequest>(
      {
        query: (date) => ({
          url: '/number-of-candidates-by-date',
          method: 'POST',
          body: date,
        }),
        providesTags: ['analytic'],
      }
    ),
    countOfJobPosts: builder.query<IAnalyticCountResponse, DateRequest>({
      query: (date) => ({
        url: '/number-of-job-posts',
        method: 'POST',
        body: date,
      }),
      providesTags: ['analytic'],
    }),
    countOfApprovedCandidates: builder.query<
      IAnalyticCountResponse,
      DateRequest
    >({
      query: (date) => ({
        url: '/number-of-accepted-candidates-by-date',
        method: 'POST',
        body: date,
      }),
      providesTags: ['analytic'],
    }),
    countOfRejectedCandidatesByDate: builder.query<
      IAnalyticCountResponse,
      DateRequest
    >({
      query: (date) => ({
        url: '/number-of-rejected-candidates-by-date',
        method: 'POST',
        body: date,
      }),
      providesTags: ['analytic'],
    }),
    athletesDistributionBySport: builder.query<
      IAthletesDistributionAnalyticResponse,
      void
    >({
      query: () => ({
        url: '/athletes-distribution-by-sport',
      }),
      providesTags: ['analytic'],
    }),
    athleteEducationLevels: builder.query<
      IAthleteEducationLevelsResponse,
      void
    >({
      query: () => ({
        url: '/athletes-education-levels',
      }),
      providesTags: ['analytic'],
    }),
  }),
});

export const {
  useGetNumberOfCandidatesQuery,
  useGetTimeToFillQuery,
  useGetNumberOfApprovedCandidatesQuery,
  useCountOfCandidatesByDateQuery,
  useCountOfJobPostsQuery,
  useCountOfApprovedCandidatesQuery,
  useCountOfRejectedCandidatesByDateQuery,
  useAthletesDistributionBySportQuery,
  useAthleteEducationLevelsQuery,
} = analyticsApi;

export default analyticsApi;
